import React from "react"
import styled, { css } from "styled-components"
import Text from "../atoms/text"
import VariantContainer, { IStyleVariant } from "../atoms/variant-container"
import mergeVariants from "../util/merge-variants"

export interface IIconTitle {
  alignmentVariants?: IStyleVariant | any
  textVariants?: IStyleVariant | any
  icon: JSX.Element
  title: string
  titleTag?: string
  iconVariants?: IStyleVariant | any
}

const Container = styled(VariantContainer)`
  display: flex;
`

const IconContainer = styled(VariantContainer)``

const BaseIconStyle = css`
  width: 24px;
  height: 24px;
  margin-right: 16px;
  flex-shrink: 0;
  display: inline-block;
  vertical-align: top;

  & > * {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
    display: inline;
  }
`

export const Alignments = {
  "row-left": css`
    align-items: center;
    text-align: left;
    justify-content: flex-start;

    & > * {
      display: inline-flex;
      flex-direction: row;
      flex-wrap: nowrap;
      align-items: center;
    }

    & ${IconContainer} {
      position: unset;
      margin: 0 16px 0 0;
    }
  `,
  "row-center": css`
    align-items: center;
    justify-content: center;
    text-align: center;
    & > * {
      display: inline-block;
      align-self: center;
    }
  `,
  "flex-row-center": css`
    & > * {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      text-align: left;
    }
    ${IconContainer} {
      position: unset;
      margin: 0 16px 0 0;
    }
  `,
  "row-overhang": css`
    position: relative;
    align-items: center;
    justify-content: flex-start;
    text-align: left;
    & ${IconContainer} {
      position: absolute;
      left: -44px;
      top: -4px;
    }
  `,
  "column-centered": css`
    text-align: center;
    justify-content: center;
    & > * {
      display: inline-flex;
      flex-direction: column;
      align-items: center;
    }
    & ${IconContainer} {
      position: unset;
      margin: 0 0 24px 0;
    }
  `,
}

export default function IconTitle({
  alignmentVariants,
  textVariants,
  icon,
  title,
  titleTag = "p",
  iconVariants,
}: IIconTitle) {
  return (
    <Container
      variants={mergeVariants([Alignments["row-left"]], alignmentVariants)}
    >
      <Text variants={textVariants} as={titleTag}>
        <IconContainer
          as="span"
          variants={mergeVariants([BaseIconStyle], iconVariants)}
        >
          {icon}
        </IconContainer>
        <span>{title}</span>
      </Text>
    </Container>
  )
}
